<div class="container flex_block justify_center">
  <div class="login_wrapper">
    <div class="loggo_wrapper">
      <img width="50px" height="50px" src="../../assets/img/GBarena-type.svg" alt="">
    </div>
    <form novalidate [formGroup]="loginForm" (ngSubmit)="onLogin(loginForm)">
      <div class="form-group">
        <div class="alert alert-danger" *ngIf="error">
          <div *ngIf="error">{{error}}</div>
        </div>
        <label for="email">E-mail</label>
        <input name="email" formControlName="email" id="email" type="text" class="form-control">
        <div class="alert alert-danger" *ngIf="loginForm.get('email').touched && !loginForm.get('email').valid">
          <div *ngIf="loginForm.get('email').errors.required"> email is required</div>
          <div *ngIf="loginForm.get('email').errors.minlength">email should be minimum 3 characters.</div>
          <div *ngIf="loginForm.get('email').errors.pattern">email should be in pattern "example@gbarena.com".</div>
        </div>
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input name="password" formControlName="password" id="password" type="password" class="form-control">
        <div class="alert alert-danger" *ngIf="loginForm.get('password').touched && !loginForm.get('password').valid">
        </div>
      </div>
      <button [disabled]="!loginForm.valid && !logging" class="login_button" type="submit"
              name="button">
        {{loginButton}}
      </button>
    </form>
  </div>
</div>
